import { createSlice } from "@reduxjs/toolkit";
import { OktaAuth } from '@okta/okta-auth-js';

const oktaNaClient: OktaAuth = new OktaAuth({
    issuer: 'https://circlek.okta.com/oauth2/default',
    clientId: '0oaewsyk7v5LeDA9W2p7',
    redirectUri: window.location.origin + '/login/callback'
});

const oktaEuClient: OktaAuth = new OktaAuth({
    issuer: 'https://circlekeurope.okta.com/oauth2/default',
    clientId: '0oa3ff097chzDItDt417',
    redirectUri: window.location.origin + '/login/callback'
});

export interface AuthState {
    authClient: OktaAuth,
    isLoggedIn: boolean
}

const initialState: AuthState = {
    authClient: oktaNaClient,
    isLoggedIn: false
}

const AuthSlice = createSlice({
    name: 'Auth',
    initialState,
    reducers: {
        setAuthState(state: any, action: any) {
            if (action.payload.typeOfLogin === 'EU') {
                state.authClient = oktaEuClient;
            }
            else {
                state.authClient = oktaNaClient;
            }
            state.isLoggedIn = action.payload.isLoggedIn;
        }
    }
});

export const AuthActions = AuthSlice.actions;

export default AuthSlice;